export var MoonBotKey = /*#__PURE__*/function (MoonBotKey) {
  MoonBotKey["btcUsdt"] = "moonBotBtcUsdt";
  MoonBotKey["ethUsdt"] = "moonBotEthUsdt";
  MoonBotKey["dipbuyingbot"] = "moonBotdipbuyingbot";
  MoonBotKey["ethBtc"] = "moonBotEthBtc";
  return MoonBotKey;
}({});
/* 补充的机器人类型 */
export var supplementaryBotTypes = /*#__PURE__*/function (supplementaryBotTypes) {
  supplementaryBotTypes["stopLimit"] = "stopLimit";
  supplementaryBotTypes["fixedPitchRobot"] = "fixedPitchRobot";
  supplementaryBotTypes["DCAGuide"] = "DCAGuide";
  supplementaryBotTypes["DCAMulti"] = "DCAMulti";
  supplementaryBotTypes["DCASingle"] = "DCASingle";
  return supplementaryBotTypes;
}({});
export var TabKey = /*#__PURE__*/function (TabKey) {
  TabKey["AI"] = "AI";
  TabKey["MANUAL"] = "MANUAL";
  TabKey["DIY"] = "DIY";
  return TabKey;
}({});
export var StableCoin = ["USDT", "BUSD", "USDC"];